import React, { useCallback } from 'react';
import { Menu, MenuItem } from '@mui/material';
import { useSplitterSupport } from 'new/hooks/useFeatureFlags';

interface HandleMenuProps {
  isOpen: boolean;
  position: { x: number; y: number } | null;
  onClose: () => void;
  onTransform: () => void;
  onTarget: () => void;
  /** Omit to hide the Split option. */
  onSplit?: () => void;
}

export const HandleMenu: React.FC<HandleMenuProps> = ({
  isOpen,
  position,
  onClose,
  onTransform,
  onTarget,
  onSplit,
}) => {
  const isSplitterEnabled = useSplitterSupport();

  const handleTransform = useCallback(() => {
    onTransform();
    onClose();
  }, [onTransform, onClose]);

  const handleTarget = useCallback(() => {
    onTarget();
    onClose();
  }, [onTarget, onClose]);

  const handleSplit = useCallback(() => {
    onSplit?.();
    onClose();
  }, [onSplit, onClose]);

  return (
    <Menu
      open={isOpen}
      onClose={onClose}
      anchorReference="anchorPosition"
      anchorPosition={
        position
          ? {
              top: position.y,
              left: position.x,
            }
          : undefined
      }
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      slotProps={{
        paper: {
          style: {
            minWidth: 120,
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
            borderRadius: 8,
            zIndex: 9999,
          },
        },
      }}
    >
      <MenuItem onClick={handleTransform}>Transform</MenuItem>
      <MenuItem onClick={handleTarget}>Connector</MenuItem>
      {isSplitterEnabled && onSplit ? <MenuItem onClick={handleSplit}>Split</MenuItem> : null}
    </Menu>
  );
};
